import type { ComponentType } from "react";
import { RouteFactory } from "@app/routePaths";
import SMELogo from "@assets/logo-sme.svg";
import aseanBusinessLogo from "@assets/verticals/asean-logo-black.svg";
import internationalGlobalLogo from "@assets/verticals/international-global-logo-blue.svg";
import AseanNewsletterDescription from "@pages/Section/layouts/Verticals/AseanBusiness/components/AseanNewsletterDescription";
import GlobalEnterpriseNewsletterDescription from "@pages/Section/layouts/Verticals/GlobalEnterprise/components/GlobalEnterpriseNewsletterDescription";
import SMENewsletterDescription from "@pages/Section/layouts/Verticals/SME/components/SMENewsletterDescription";

export const ASEAN_DESCRIPTION =
  "Your go-to portal for up-to-date business guides, information, and resources for all businesses and investors with an interest in ASEAN.";
export const SGSME_DESCRIPTION =
  "A news-driven repository of information and knowledge for Singapore's SMEs";
export const GLOBAL_DESCRIPTION =
  "Everything you need to know about Global Enterprise and the people behind them.";

export const VERTICAL_MASTHEADS = {
  global: {
    alt: "Global Enterprise logo",
    src: internationalGlobalLogo,
    width: 185,
    height: 50,
  },
  asean: {
    alt: "Asean Business logo",
    src: aseanBusinessLogo,
    width: 200,
    height: 57,
  },
  sme: {
    alt: "SGSME logo",
    src: SMELogo,
    width: 126,
    height: 31,
  },
};

export const VERTICAL_NEWSLETTER_DESC_COMPONENT: Record<string, ComponentType> =
  {
    [RouteFactory.sgsmeLatest]: SMENewsletterDescription,
    [RouteFactory.aseanBusinessLatest]: AseanNewsletterDescription,
    [RouteFactory.globalEnterpriseLatest]:
      GlobalEnterpriseNewsletterDescription,
  };

export const VERTICAL_NEWSLETTER_COLORS_PROPS: Record<
  string,
  Record<string, string>
> = {
  [RouteFactory.sgsmeLatest]: {
    btnColors:
      "bg-verticals-sme text-white hover:bg-white hover:text-verticals-sme",
    linkColors: "text-verticals-sme",
  },
  [RouteFactory.aseanBusinessLatest]: {
    btnColors:
      "bg-verticals-asean text-white hover:bg-white hover:text-verticals-sme",
    linkColors: "text-verticals-asean",
  },
  [RouteFactory.globalEnterpriseLatest]: {
    btnColors:
      "bg-verticals-ge text-white hover:bg-white hover:text-verticals-ge",
    linkColors: "text-verticals-ge",
  },
};
